import styled from "styled-components";


export const Body = styled.body`
 margin:none;

  
`

